import React from 'react'

export function ChildrenOrHidden (props) {
  const childrenArray = React.Children.toArray(props.children)
  let toReturn = <div>{props.children}</div>
  if (childrenArray.length === 0) {
    toReturn = <div className='hidden' />
  }
  return toReturn
}

export default ChildrenOrHidden



// WEBPACK FOOTER //
// ./src/components/ChildrenOrHidden/index.js